"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.some.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

var _cartPreviewer = _interopRequireDefault(require("@store/cart-previewer"));

var _UserAgent = _interopRequireDefault(require("fbjs/lib/UserAgent"));

var _submenu = _interopRequireDefault(require("../submenu"));

var _Arrow = _interopRequireDefault(require("./Arrow"));

var _Icon = _interopRequireDefault(require("../menu/Icon"));

var _SearchAction = _interopRequireDefault(require("./SearchAction"));

var _CartCount = _interopRequireDefault(require("../menu/CartCount"));

var _menu = require("../constants/menu");

var _utils = require("./utils");

var _useButtonSettings2 = _interopRequireDefault(require("../hooks/useButtonSettings"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

require("./styles/navItem.less");

var styles = {
  "root": "meepshop-meep-ui__nav-navItem__root",
  "text": "meepshop-meep-ui__nav-navItem__text",
  "pattern-0": "meepshop-meep-ui__nav-navItem__pattern-0",
  "isActive": "meepshop-meep-ui__nav-navItem__isActive",
  "rootOpen": "meepshop-meep-ui__nav-navItem__rootOpen",
  "pattern-1": "meepshop-meep-ui__nav-navItem__pattern-1",
  "pattern-2": "meepshop-meep-ui__nav-navItem__pattern-2",
  "pattern-3": "meepshop-meep-ui__nav-navItem__pattern-3",
  "pattern-4": "meepshop-meep-ui__nav-navItem__pattern-4",
  "textWrapper": "meepshop-meep-ui__nav-navItem__textWrapper",
  "duplicate": "meepshop-meep-ui__nav-navItem__duplicate",
  "cartContainer": "meepshop-meep-ui__nav-navItem__cartContainer",
  "popover": "meepshop-meep-ui__nav-navItem__popover",
  "group": "meepshop-meep-ui__nav-navItem__group",
  "arrow": "meepshop-meep-ui__nav-navItem__arrow",
  "open": "meepshop-meep-ui__nav-navItem__open",
  "close": "meepshop-meep-ui__nav-navItem__close",
  "expandTitle": "meepshop-meep-ui__nav-navItem__expandTitle",
  "expandSubItem": "meepshop-meep-ui__nav-navItem__expandSubItem",
  "subItem": "meepshop-meep-ui__nav-navItem__subItem"
};
var DEVICE_PLATFORM = ['Android', 'Windows Phone', 'iOS'];
var defaultSubmenuSettings = {
  showThirdLevelMenuDivider: false,
  imageSettings: {
    ratio: '1 / 1',
    color: '#8c8c8c',
    alignment: 'CENTER',
    // files
    newWindow: false,
    alt: '',
    href: '',
    url: '',
    // 標題
    showTitle: true,
    titleText: '圖片文字標題',
    titleFontSize: 28,
    titleBold: false,
    // 按鈕
    showButton: true,
    buttonText: 'more',
    buttonFontSize: 22
  },
  productSettings: {
    ids: [],
    imageRatio: '1 / 1',
    imageTextAlignment: 'VERTICAL',
    sort: 'createdAt-desc'
  }
};

var NavItem = function NavItem(_ref) {
  var _page$pages;

  var pageProps = _ref.page,
      menuSettings = _ref.menuSettings,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 0 : _ref$level;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useContext = (0, _react.useContext)(_DecoratorsRoot.EnhancerContext),
      user = _useContext.user,
      isLogin = _useContext.isLogin,
      hasStoreAppPlugin = _useContext.hasStoreAppPlugin;

  var page = _objectSpread(_objectSpread({}, pageProps), {}, {
    // 將頁面補齊資料
    pages: level === 0 ? (0, _utils.getPages)(pageProps, {
      user: user,
      isLogin: isLogin,
      hasStoreAppPlugin: hasStoreAppPlugin
    }) // 只有第一層要處理
    : pageProps.pages || []
  });

  var _useButtonSettings = (0, _useButtonSettings2["default"])(page, {
    menuSettings: menuSettings
  }),
      title = _useButtonSettings.title,
      action = _useButtonSettings.action,
      isActive = _useButtonSettings.isActive,
      hasGroup = _useButtonSettings.hasGroup,
      url = _useButtonSettings.url,
      target = _useButtonSettings.target;

  var _useMemo = (0, _react.useMemo)(function () {
    return [pageProps.submenuType || _menu.SUBMENU_TYPES.DROP_DOWN, pageProps.submenuSettings || defaultSubmenuSettings];
  }, [pageProps]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 2),
      submenuType = _useMemo2[0],
      submenuSettings = _useMemo2[1];

  var expandSubItem = menuSettings.expandSubItem;
  var hasSubItems = expandSubItem && ((_page$pages = page.pages) === null || _page$pages === void 0 ? void 0 : _page$pages.length) > 0;
  var isExpandTitle = expandSubItem && level === 0;
  var isExpandSubItem = expandSubItem && level > 0;
  var iconProps = (0, _utils.getIconProps)(page, {
    isLogin: isLogin
  });
  var baseClassName = [styles.root, isExpandTitle && styles.expandTitle, isExpandSubItem && styles.expandSubItem, !expandSubItem && styles["pattern-".concat(menuSettings.pattern)], isActive ? styles.isActive : ''].filter(Boolean).join(' ');
  var rootStyles = {
    '--icon-size': menuSettings.iconSize && ['UPON', 'BELOW'].includes(iconProps.imagePosition) ? "".concat(menuSettings.iconSize, "px") : undefined
  };
  var baseStyles = {
    minHeight: expandSubItem ? undefined : menuSettings.height,
    paddingLeft: expandSubItem && level ? "".concat(level * 20, "px") : undefined,
    fontSize: isExpandSubItem ? menuSettings.submenuFontSize : undefined
  };
  var renderText = iconProps.image ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, iconProps, {
    iconSize: menuSettings.iconSize
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.text
  }, title)) : /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.text
  }, title);
  var renderInner = hasGroup ? /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.textWrapper
  }, renderText, /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
    className: "".concat(styles.arrow, " ").concat(open ? styles.open : styles.close, " submenu-arrow")
  })) : /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.textWrapper
  }, renderText);
  var renderDuplicate = menuSettings.pattern === _menu.PATTERN_TYPES.ROUNDED_CORNER ? /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.duplicate
  }, renderInner) : null;

  if (page.action === _menu.MENU_ACTION_TYPES.SEARCH_BAR) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: rootStyles
    }, /*#__PURE__*/_react["default"].createElement(_SearchAction["default"], {
      className: baseClassName,
      style: baseStyles,
      title: title
    }));
  } // 購物車按鈕


  if (page.action === _menu.MENU_ACTION_TYPES.CART) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: styles.cartContainer,
      style: rootStyles
    }, /*#__PURE__*/_react["default"].createElement(_CartCount["default"], {
      showCartCount: true
    }, /*#__PURE__*/_react["default"].createElement(_cartPreviewer["default"], {
      viewer: user
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: baseClassName,
      style: baseStyles
    }, renderInner, renderDuplicate))));
  } // 有下拉選單的按鈕


  if (hasGroup) {
    var Comp = url ? _link["default"] : _react.Fragment;
    var compProps = url ? {
      href: url,
      target: target
    } : {};
    var isDevice = DEVICE_PLATFORM.some(function (platform) {
      return _UserAgent["default"].isPlatform(platform);
    });

    var handleGroupClick = function handleGroupClick(e) {
      var _e$target;

      // 在平板裝置上，如果是點擊箭頭，不會觸發跳轉
      if ((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.closest('.submenu-arrow') && url && isDevice) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      return true;
    };

    return /*#__PURE__*/_react["default"].createElement(_submenu["default"], {
      page: page,
      style: rootStyles,
      menuSettings: menuSettings,
      submenuType: submenuType,
      submenuSettings: submenuSettings,
      onVisibleChange: setOpen,
      renderChildren: function renderChildren() {
        return /*#__PURE__*/_react["default"].createElement(Comp, compProps, /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(baseClassName, " ").concat(open ? styles.rootOpen : ''),
          style: baseStyles,
          onClick: handleGroupClick
        }, renderInner, renderDuplicate));
      }
    });
  } // 有 action 的按鈕


  if (action) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: rootStyles
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: baseClassName,
      style: baseStyles,
      onClick: action,
      type: "button"
    }, renderInner, renderDuplicate), hasSubItems && /*#__PURE__*/_react["default"].createElement("div", {
      className: styles.subItem
    }, page.pages.map(function (subPage) {
      return /*#__PURE__*/_react["default"].createElement(NavItem, {
        key: subPage.id,
        page: subPage,
        menuSettings: menuSettings,
        level: level + 1
      });
    })));
  } // 一般的按鈕


  return /*#__PURE__*/_react["default"].createElement("div", {
    style: rootStyles
  }, /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: url,
    passHref: true,
    target: target
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    className: baseClassName,
    style: baseStyles,
    target: target
  }, renderInner, renderDuplicate)), hasSubItems && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.subItem
  }, page.pages.map(function (subPage) {
    return /*#__PURE__*/_react["default"].createElement(NavItem, {
      key: subPage.id,
      page: subPage,
      menuSettings: menuSettings,
      level: level + 1
    });
  })));
};

var _default = NavItem;
exports["default"] = _default;